module.exports = __webpack_public_path__ + "static/img/phone_back.55bea08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/phone_back.jpg?20181011
// module id = xlBZ
// module chunks = 1